export default "__VITE_ASSET__Dm2yAR3R__"